import { createContext, useContext } from "react";
import type { AuthenticatedUser } from "../shared/schemas";

export interface SnapshotTerm {
  id: string;
  termCode: string;
  displayName: string;
  status: string;
  isActive: boolean;
  sectionCount: number;
  activatedAt: string | null;
  createdAt: string;
}

export interface DepartmentOption {
  code: string;
  sectionCount: number;
}

interface AppContextValue {
  user: AuthenticatedUser;
  terms: SnapshotTerm[];
  snapshotTermId: string;
  setSnapshotTermId: (value: string) => void;
  departments: DepartmentOption[];
  departmentId: string;
  setDepartmentId: (value: string) => void;
}

export const AppContext = createContext<AppContextValue | null>(null);

export function useAppContext(): AppContextValue {
  const context = useContext(AppContext);
  if (!context) throw new Error("useAppContext must be used inside AppShell.");
  return context;
}
